// src/App.js
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import BookingFlow from './components/BookingFlow';

function App() {
  return (
    <Routes>
      <Route path="/createbooking" element={<BookingFlow />} />
      
      {/* Redirect "/" to "/createbooking" */}
      <Route path="/" element={<Navigate to="/createbooking" replace />} />
    </Routes>
  );
}

export default App;
